import axios from "axios";

// const
const NAMESPACE_VERIFY_UPDATE_DATA = "namespaceVerify/NAMESPACE_VERIFY_UPDATE_DATA";
const NAMESPACE_VERIFY_STORE_NAMESPACES = "namespaceVerify/NAMESPACE_VERIFY_STORE_NAMESPACES";
const NAMESPACE_VERIFY_STORE_VERSIONS = "namespaceVerify/NAMESPACE_VERIFY_STORE_VERSIONS";
const NAMESPACE_VERIFY_TOGGLE_MODAL = "namespaceVerify/NAMESPACE_VERIFY_TOGGLE_MODAL";
const NAMESPACE_VERIFY_TOGGLE_LOADING = "namespaceVerify/NAMESPACE_VERIFY_TOGGLE_LOADING";

const NAMESPACE_VERIFY_MODAL_SUCCESS_TITLE = "scenes_Namespace_NamespaceVerify_modal_success_title";
const NAMESPACE_VERIFY_MODAL_FAIL_TITLE = "scenes_Namespace_NamespaceVerify_modal_fail_title";
const NAMESPACE_VERIFY_MODAL_AUDIT_SUCCESS_CONTENT = "scenes_Namespace_NamespaceVerify_modal_auditSuccess_content";
const NAMESPACE_VERIFY_MODAL_AUDIT_FAIL_CONTENT = "scenes_Namespace_NamespaceVerify_modal_auditFail_content";
const NAMESPACE_VERIFY_MODAL_OK_LABEL = "scenes_Namespace_NamespaceVerify_modal_OK_label";
const NAMESPACE_VERIFY_MODAL_CANCEL_LABEL = "scenes_Namespace_NamespaceVerify_modal_cancel_label";

// reducer
export const namespaceVerify = (state = {

  loading: false,

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  messageInfo: {},

  name: "",
  selectedNamespace: "",
  namespaces: [],
  showNamespaces: [],
  namespaceInfo: {},
  selectedVersion: "",
  versions: [],
  showVersions: [],
  enterprises: []
}, action) => {
  switch (action.type) {
    case NAMESPACE_VERIFY_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case NAMESPACE_VERIFY_STORE_NAMESPACES:
      return {
        ...state,
        name: "",
        selectedNamespace: "",
        namespaces: action.data,
        showNamespaces: action.data,
        enterprises: action.data.enterpriseId,
      };
    case NAMESPACE_VERIFY_STORE_VERSIONS:
      return {
        ...state,
        namespaceInfo: {},
        selectedVersion: "",
        versions: action.data,
        showVersions: action.data,
      };
    case NAMESPACE_VERIFY_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case NAMESPACE_VERIFY_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based
 */
export const updateNamespaceVerifyData = (data) => {
  return {
    type: NAMESPACE_VERIFY_UPDATE_DATA,
    data: data
  }
};


/**
 * get NAMESPACE for verify
 */
export const getNamespaces = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-tenant/namespace/getNamespaceForVerify`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeNamespaces(response.data));
        dispatch(toggleLoading(false));
        console.log(response.data);
      }
    }
  );
};
/**
 * store all app namespaces
 */
export const storeNamespaces = (namespaces) => {
  return {
    type: NAMESPACE_VERIFY_STORE_NAMESPACES,
    data: namespaces
  }
};

/**
 * update namespace status

 */
export const updateNamespaceStatus = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "PUT",
    url: `/api-tenant/namespace/updateNamespaceStatus`,
    contentType: "application/json",
    withCredentials: true,
    // data: {
    //   id: data.id,
    // }
    data: data.id
  }).then(
    response => {
      if (response.status === 200) {
        console.info("success audit namespace");
        dispatch(toggleLoading(false));
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: NAMESPACE_VERIFY_MODAL_SUCCESS_TITLE,
          modalContent: NAMESPACE_VERIFY_MODAL_AUDIT_SUCCESS_CONTENT,
          modalOk: NAMESPACE_VERIFY_MODAL_OK_LABEL,
          modalCancel: NAMESPACE_VERIFY_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(getNamespaces());
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(getNamespaces());
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
        dispatch(sendMessage({
          actorId: data.messageInfo.actorId,
          notifierId: data.messageInfo.notifierId,
          namespaceName: data.messageInfo.namespaceName,
          version: "",
          result: data.code === "2" ? "审核通过" : "审核不通过",
        }));
      } else {
        console.warn("fail to audit namespace");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: NAMESPACE_VERIFY_MODAL_FAIL_TITLE,
          modalContent: NAMESPACE_VERIFY_MODAL_AUDIT_FAIL_CONTENT,
          modalOk: NAMESPACE_VERIFY_MODAL_OK_LABEL,
          modalCancel: NAMESPACE_VERIFY_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
    }
  );
};

/**
 * get version for verify
 */
export const getVersions = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-tenant/getVersionForVerify`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeVersions(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all version
 */
export const storeVersions = (versions) => {
  return {
    type: NAMESPACE_VERIFY_STORE_VERSIONS,
    data: versions
  }
};

/**
 * filter namespace||version data
 */
export const filterData = (data) => (dispatch) => {
  let showNamespaces = data.namespaces.filter(namespace => {
    return namespace.name.indexOf(data.name) > -1
  });
  dispatch(updateNamespaceVerifyData({
    name: "showNamespaces",
    value: showNamespaces
  }));
  dispatch(updateNamespaceVerifyData({
    name: "selectedApp",
    value: ""
  }));

  let showVersions = data.versions.filter(version => {
    return version.majorVersion.namespace.name.indexOf(data.name) > -1
  });
  dispatch(updateNamespaceVerifyData({
    name: "showVersions",
    value: showVersions
  }));
  dispatch(updateNamespaceVerifyData({
    name: "selectedVersion",
    value: ""
  }));
};

/**
 * update version status
 */
export const updateVersionStatus = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "PUT",
    url: `/api-namespace/updateVersionStatus`,
    contentType: "namespace/json",
    withCredentials: true,
    data: {
      id: data.id,
      status: {code: data.code}
    }
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200) {
        console.info("success audit version");
        if (data.code === "2") {
          console.info("app version publish", data.namespaceInfo);
          axios({
            url: `/api-tenant/app/publish`,
            method: "POST",
            data: data.namespaceInfo
          })
        }
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: NAMESPACE_VERIFY_MODAL_SUCCESS_TITLE,
          modalContent: NAMESPACE_VERIFY_MODAL_AUDIT_SUCCESS_CONTENT,
          modalOk: NAMESPACE_VERIFY_MODAL_OK_LABEL,
          modalCancel: NAMESPACE_VERIFY_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(getVersions());
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(getVersions());
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
        dispatch(sendMessage({
          actorId: data.messageInfo.actorId,
          notifierId: data.messageInfo.notifierId,
          namespaceName: data.messageInfo.namespaceName,
          version: `-${data.messageInfo.version}`,
          result: data.code === "2" ? "审核通过" : "审核不通过",
        }));
      } else {
        console.warn("fail to audit version");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: NAMESPACE_VERIFY_MODAL_FAIL_TITLE,
          modalContent: NAMESPACE_VERIFY_MODAL_AUDIT_FAIL_CONTENT,
          modalOk: NAMESPACE_VERIFY_MODAL_OK_LABEL,
          modalCancel: NAMESPACE_VERIFY_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
    }
  );
};

/**
 * send message
 */
export const sendMessage = (data) => (dispatch) => {
  axios({
    method: "post",
    url: "/api-user/notificationObjects",
    contentType: "namespace/json",
    withCredentials: true,
    data: {
      "actorId": data.actorId,
      "notifierIds": data.notifierId,
      "title": `审核通知`,
      "description": `您提交的应用【${data.namespaceName}${data.version}】${data.result}！`,
      "type": "审核消息",
      "selfType": "01",
      "action": data.result,
    }
  }).then(
    response => {
      if (response.status === 200) {
        console.info("success to send a message");
      } else {
        console.error("fail to send a message")
      }
    },
    error => {
      console.error("fail to send a message", error)
    }
  );
};


/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: NAMESPACE_VERIFY_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: NAMESPACE_VERIFY_TOGGLE_LOADING,
    data: show
  }
};
